import { useId } from 'react';
import { LANGUAGES, useLanguageStore, useT, type Language } from './i18n';

/** Chooses the language of the screens that are translated (kept on this device). */
export function LanguagePicker({ className = '' }: { className?: string }) {
  const id = useId();
  const t = useT();
  const { language, setLanguage } = useLanguageStore();
  return (
    <div className={`flex items-center gap-2 text-sm ${className}`}>
      <label htmlFor={id} className="text-muted">
        {t('Language')}
      </label>
      <select
        id={id}
        value={language}
        onChange={(e) => setLanguage(e.target.value as Language)}
        className="rounded-md border border-line bg-panel2 px-2 py-0.5 text-sm"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {l.name}
          </option>
        ))}
      </select>
    </div>
  );
}
